import GeneralInscription from "./GeneralInscription";

export default GeneralInscription;
